<div class="map-container">
    <!-- Header Section -->
    <div class="map-header">
        <div class="header-content">
            <div class="title-section">
                <i class="mdi mdi-map-marker-radius mr-2"></i>
                <h3 class="map-title">Map</h3>
            </div>
            <div class="header-actions">
                <app-search-input [placeholder]="'Search by ID, Name or Address...'" (searchChange)="onSearch($event)"></app-search-input>
                <div class="info-item">
                    <i class="mdi mdi-account-group text-success"></i>
                    <span class="info-label">Total Clients:</span>
                    <span class="info-value">{{ totalClients }}</span>
                </div>
                <button class="btn btn-outline-primary btn-sm" (click)="centerMap()">
                    <i class="mdi mdi-crosshairs-gps mr-1"></i>
                    Center Map
                </button>
            </div>
        </div>
    </div>

    <!-- Map Section -->
    <div class="map-wrapper">
        <div class="map-content">
            <div #mapContainer id="map"></div>
        </div>

        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loading-content">
                <i class="fa fa-spinner fa-spin fa-3x"></i>
                <p>Loading report...</p>
            </div>
        </div>
    </div>
</div>